"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function IOImagesOutline(props) {
    let { width, height, size } = props;
    if (size !== undefined) {
        width = size;
        height = size;
    }
    if (width === undefined && height === undefined) {
        width = 16;
        height = 16;
    }
    return (react_1.default.createElement("svg", { className: "glx--icon glx-io-icon", width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinejoin: "round", strokeWidth: "32", d: "M432 112V96a48.14 48.14 0 00-48-48H64a48.14 48.14 0 00-48 48v256a48.14 48.14 0 0048 48h16" }),
        react_1.default.createElement("rect", { width: "400", height: "336", x: "96", y: "128", fill: "none", stroke: "#000", strokeLinejoin: "round", strokeWidth: "32", rx: "45.99", ry: "45.99" }),
        react_1.default.createElement("ellipse", { cx: "372.92", cy: "219.64", fill: "none", stroke: "#000", strokeMiterlimit: "10", strokeWidth: "32", rx: "30.77", ry: "30.55" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M342.15 372.17L255 285.78a30.93 30.93 0 00-42.18-1.21L96 387.64M265.23 464l118.59-117.73a31 31 0 0141.46-1.87L496 402.91" })));
}
exports.default = IOImagesOutline;
